import { ANALYTICS_ACTIONS } from '../actions/analyticsActions';

export const initialState = {
	loading:       false,
	error:         null,
	days:          21,
	topN:          10,
	topModules:    [],
	topUsers:      [],
	daily:         [],
	hourly:        [],
	recentLog:     [],
	totalViews:    0,
	activeModules: 0,
	activeUsers:   0,
	lastRefresh:   null,

	availableRoles:    [],
	availableProjects: [],

	// active filters
	// project is a "background" filter like role — can coexist with module/user drill-down
	selectedProject: null,   // string (projectName) or null
	selectedRole:    null,   // { id, label }
	selectedModule:  null,   // { id, label }
	selectedUser:    null,   // { id, label }
	filterType:      null,   // 'module' | 'user' | 'role' | 'project' | null

	filterLoading:         false,
	filterError:           null,
	filteredModules:       [],
	filteredUsers:         [],
	filteredDaily:         [],
	filteredHourly:        [],
	filteredRecentLog:     [],
	filteredTotalViews:    0,
	filteredActiveModules: 0,
	filteredActiveUsers:   0,

	selectedDate:      null,
	dateHourly:        [],
	dateRecentLog:     [],
	dateHourlyLoading: false,
	dateHourlyError:   null,
};

const clearDrillDown = {
	selectedModule:        null,
	selectedUser:          null,
	filterLoading:         false,
	filterError:           null,
	filteredModules:       [],
	filteredUsers:         [],
	filteredDaily:         [],
	filteredHourly:        [],
	filteredRecentLog:     [],
	filteredTotalViews:    0,
	filteredActiveModules: 0,
	filteredActiveUsers:   0,
};

// Derive filterType from state after background filters change
function deriveFilterType(selectedRole, selectedProject) {
	if (selectedRole && selectedProject) return 'role+project';
	if (selectedRole)    return 'role';
	if (selectedProject) return 'project';
	return null;
}

export function analyticsReducer(state, action) {
	switch (action.type) {

					case ANALYTICS_ACTIONS.FETCH_DASHBOARD_START:
						return { ...state, loading: true, error: null };

					case ANALYTICS_ACTIONS.FETCH_DASHBOARD_SUCCESS:
						return {
							...state,
							loading:       false, error: null,
							lastRefresh:   new Date().toISOString(),
							topModules:    action.payload.topModules    ?? [],
							topUsers:      action.payload.topUsers      ?? [],
							daily:         action.payload.daily         ?? [],
							hourly:        action.payload.hourly        ?? [],
							recentLog:     action.payload.recentLog     ?? [],
							totalViews:    action.payload.totalViews    ?? 0,
							activeModules: action.payload.activeModules ?? 0,
							activeUsers:   action.payload.activeUsers   ?? 0,
						};

					case ANALYTICS_ACTIONS.FETCH_DASHBOARD_ERROR:
						return { ...state, loading: false, error: action.error };

					case ANALYTICS_ACTIONS.FETCH_FILTERED_START:
						return { ...state, filterLoading: true, filterError: null };

					case ANALYTICS_ACTIONS.FETCH_FILTERED_SUCCESS:
						return {
							...state,
							filterLoading:         false, filterError: null,
							filteredModules:       action.payload.topModules    ?? [],
							filteredUsers:         action.payload.topUsers      ?? [],
							filteredDaily:         action.payload.daily         ?? [],
							filteredHourly:        action.payload.hourly        ?? [],
							filteredRecentLog:     action.payload.recentLog     ?? [],
							filteredTotalViews:    action.payload.totalViews    ?? 0,
							filteredActiveModules: action.payload.activeModules ?? 0,
							filteredActiveUsers:   action.payload.activeUsers   ?? 0,
						};

					case ANALYTICS_ACTIONS.FETCH_FILTERED_ERROR:
						return { ...state, filterLoading: false, filterError: action.error };

					case ANALYTICS_ACTIONS.FETCH_HOURLY_START:
						return { ...state, dateHourlyLoading: true, dateHourlyError: null };

					case ANALYTICS_ACTIONS.FETCH_HOURLY_SUCCESS:
						return { ...state, dateHourlyLoading: false, dateHourly: action.payload.hourly ?? [], dateRecentLog: action.payload.recentLog ?? [] };

					case ANALYTICS_ACTIONS.FETCH_HOURLY_ERROR:
						return { ...state, dateHourlyLoading: false, dateHourlyError: action.error };

					case ANALYTICS_ACTIONS.FETCH_ROLES_SUCCESS:
						return { ...state, availableRoles: action.roles ?? [] };

					case ANALYTICS_ACTIONS.FETCH_PROJECTS_SUCCESS:
						return { ...state, availableProjects: action.projects ?? [] };

					case ANALYTICS_ACTIONS.SET_DAYS_FILTER:
						return { ...state, days: action.days };

					case ANALYTICS_ACTIONS.SET_TOP_N:
						return { ...state, topN: action.topN };

					case ANALYTICS_ACTIONS.SET_MODULE_FILTER:
						return { ...state, filterType: 'module', selectedModule: action.module, selectedUser: null };

					case ANALYTICS_ACTIONS.SET_USER_FILTER:
						return { ...state, filterType: 'user', selectedUser: action.user, selectedModule: null };

					case ANALYTICS_ACTIONS.SET_ROLE_FILTER:
						return {
							...state,
							...clearDrillDown,
							selectedRole: action.role,
							selectedModule: null, selectedUser: null,
							filterType: deriveFilterType(action.role, state.selectedProject),
						};

					case ANALYTICS_ACTIONS.SET_PROJECT_FILTER:
						return {
							...state,
							...clearDrillDown,
							selectedProject: action.project,
							selectedModule: null, selectedUser: null,
							filterType: deriveFilterType(state.selectedRole, action.project),
						};

					case ANALYTICS_ACTIONS.SET_DATE_FILTER:
						return { ...state, selectedDate: action.date, dateHourly: [], dateRecentLog: [], dateHourlyLoading: false };

					case ANALYTICS_ACTIONS.CLEAR_FILTER:
						return {
							...state, ...clearDrillDown,
							filterType: null, selectedRole: null, selectedProject: null,
						};

					case ANALYTICS_ACTIONS.CLEAR_DRILL_DOWN: {
						const ft = deriveFilterType(state.selectedRole, state.selectedProject);
						return { ...state, ...clearDrillDown, filterType: ft };
					}

					case ANALYTICS_ACTIONS.CLEAR_DATE_FILTER:
						return { ...state, selectedDate: null, dateHourly: [], dateRecentLog: [], dateHourlyLoading: false, dateHourlyError: null };

					case ANALYTICS_ACTIONS.TRACK_ACCESS_SUCCESS:
						return {
							...state,
							recentLog:  [action.entry, ...state.recentLog].slice(0, 100),
							totalViews: state.totalViews + 1,
						};

					default:
						return state;
	}
}